import styled from 'styled-components';

export default styled.input`
  width: 100%;
  padding: 11px 10px;
  line-height: 22px;
  background-color: ${({ theme, error }) =>
    error ? theme.defaultColors.errorBackground : theme.defaultColors.white};
  border: 1px solid
    ${({ theme, error }) => (error ? theme.defaultColors.error : theme.defaultColors.grey)};
  border-radius: 3px;
  transition: 0.3s all;
  font-size: 16px;
  color: ${({ theme }) => theme.defaultColors.fontPrimary};

  &::placeholder {
    color: ${({ theme }) => theme.defaultColors.grey};
  }

  &:focus {
    border-color: ${({ theme }) => theme.customColors.primary};
  }

  &:disabled {
    opacity: 0.4;
  }
`;
